import React from "react";
import FormLabel from "components/form/FormLabel";


type PropsType = {
  name: string
  forName?: string
  label: string | React.ReactNode
  required?: boolean
  onChange: (checked: boolean) => void
  checked: boolean
  className?: string
  checkboxClassName?: string
  disabled?: boolean
  error?: string | null
}

function FormCheckbox(props: PropsType) {
  const {
    name = "",
    forName = "",
    label = "",
    required = false,
    onChange,
    checked,
    className = "",
    checkboxClassName = "",
    disabled = false,
    error = null
  } = props;

  return (
    <div className="c__input">
      <div className={`flex flex-row items-center justify-start ${className}`}>
        <input id={forName ? forName : name}
               className={`${checkboxClassName} ${disabled ? "" : "cursor-pointer"}`}
               type="checkbox"
               onChange={(e) => {
                 if (disabled) return;
                 onChange(e.target.checked);
               }}
               disabled={disabled}
               checked={checked} />
        <FormLabel htmlFor={forName ? forName : name}
                   required={required}
                   className={`block pl-2 text-xs text-left font-medium text-gray-700 ${disabled ? "" : "cursor-pointer"}`}>
          {label}
        </FormLabel>
      </div>
      {error && (
        <p className="error">{error}</p>
      )}
    </div>
  );
}

export default FormCheckbox;
